<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <v-row class="px-6">
          <v-col cols="12" md="10">
            <v-text-field
              v-model="filterSearch.search"
              @input="searchFunc"
              clearable
              class="rounded-lg pr-0 sm-font400-14"
              solo
              append-icon="mdi-magnify"
              placeholder="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              block
              color="positive"
              to="/metrics/create"
              class="white--text rounded-xl sm-font400-13"
              height="48"
            >
              افزودن متریک
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="sm-font400-13 textTable--text"
              :headers="headers"
              :items="items"
              hide-default-footer
              no-results-text="دیتایی وجود ندارد!"
              :loading="loading"
              loading-text="در حال بارگذاری..."
              item-key="id"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  :to="`/metrics/edit/${item.id}`"
                  color="positive"
                  icon
                  title="ویرایش"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click="openDeleteModal(item)"
                  color="nagative"
                  icon
                  title="حذف"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
          <v-col v-if="totalPages > 1" cols="12">
            <v-pagination
              v-model="filterSearch.page"
              :length="totalPages"
              @input="getData"
              color="thirdColor"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog v-model="showDeleteModal" width="500">
        <v-card class="pa-10 text-center">
          <h3 class="mb-5">آیا از حذف این متریک مطمئن هستید؟</h3>
          <div class="text-center">
            <v-btn
              width="130"
              height="48"
              color="gray"
              outlined
              class="me-2 rounded-xl"
              @click="showDeleteModal = false"
            >
              بازگشت
            </v-btn>
            <v-btn
              :loading="loadingDelete"
              @click="deleteItem"
              width="130"
              height="48"
              class="white--text rounded-xl"
              color="nagative"
            >
              حذف
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import metrics from "@/Services/modules/metrics";

export default {
  name: "MetricsListView",
  data() {
    return {
      showDeleteModal: false,
      loadingDelete: false,
      selectedItem: null,
      filterSearch: {
        page: Number(this.$route.query.page) || 1,
        search: this.$route.query.search || "",
      },
      loading: false,
      headers: [
        { text: "شناسه", value: "id", width: "80" },
        { text: "عنوان", value: "title" },
        { text: "واحد", value: "unit" },
        { text: "عملیات", value: "actions", align: "center", width: "150" },
      ],
      items: [],
      totalPages: 1,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      metrics
        .getAll(this.filterSearch)
        .then((res) => {
          const data = res.data;
          this.items = data.results || data.data || data || [];
          this.totalPages = data.page_count || data.total_pages || Math.ceil((data.count || this.items.length) / 10) || 1;
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchFunc() {
      this.$router.push({
        query: {
          ...this.$route.query,
          search: this.filterSearch.search,
          page: 1,
        },
      });
      this.filterSearch.page = 1;
      this.getData();
    },
    openDeleteModal(item) {
      this.selectedItem = item;
      this.showDeleteModal = true;
    },
    deleteItem() {
      if (!this.selectedItem?.id) return;
      this.loadingDelete = true;
      metrics
        .delete(this.selectedItem.id)
        .then(() => {
          this.$toast.success("با موفقیت حذف شد!");
          this.showDeleteModal = false;
          this.selectedItem = null;
          this.getData();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
  },
};
</script>
